module.exports = __webpack_public_path__ + "img/introducePageFive_show_four.5f7c9b47.jpg";